import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { includes } from 'lodash'

import { useCourseStatus } from 'global/hooks/useUserCouseStatus'

import { getLocationPathname } from 'utils/html/window'

import {
  CourseComponentNav,
  CourseComponentItem
} from 'components/CourseComponent'

import styles from './styles.module.scss'

const CourseNav = ({
  baseUrl,
  courseComponents,
  customPathName,
  customUserId,
  disableChangeRoute = false
}) => {
  const { userId } = useParams()

  const courseRef = useRef(null)
  const history = useHistory()
  const [currentStage, setCurrentStage] = useState(null)

  const { courseStatusData } = useCourseStatus(
    customUserId || userId
  )

  const findActiveStage = courseStatusData?.findIndex(
    course => course.status === false
  )

  const doneSteps = courseStatusData?.filter(
    course => course.status === true
  )

  const allStepsDone =
    doneSteps?.length === courseStatusData?.length

  // if allSteps are done, activeStageIndex should be larger than courseStatusData to show of the steps are done. Else, activeStepIndex should be 0
  const activeStageIndex =
    findActiveStage < 0
      ? allStepsDone
        ? courseStatusData?.length + 1
        : 0
      : findActiveStage

  const handleCourseClick = async (to, index) => {
    const scrollConfig = {
      behavior: 'smooth',
      block: 'end',
      inline: 'center'
    }

    const element =
      courseRef?.current?.children[0].children[index]
    if (element) {
      await element.scrollIntoView(scrollConfig)
    }

    if (!disableChangeRoute) {
      history.push(to)
    }
  }

  useEffect(() => {
    if (currentStage) {
      const { to, index } = currentStage
      handleCourseClick(to, index)
    }
    // eslint-disable-next-line
  }, [currentStage])

  return (
    <CourseComponentNav
      className="mb-35"
      containerClassName={styles.courseNav}
      courseRef={courseRef}
    >
      {courseComponents.map((component, index) => {
        const { title, to } = component
        const isFirst = index === 0
        const isLast = index === courseComponents.length - 1
        const pathname = customPathName || getLocationPathname()

        const extractedPathname = pathname
          .split(baseUrl)[1]
          .split('/')[1]
        const extractedTo = to.split(baseUrl)[1].split('/')[1]

        const isOnCurrentLocation = includes(
          extractedPathname,
          extractedTo
        )

        const showStatus = index <= activeStageIndex

        const currentCourse = courseStatusData?.find(
          course => course.title === title
        )

        if (isOnCurrentLocation && !currentStage) {
          setCurrentStage({ to, index })
        }

        return (
          <CourseComponentItem
            isCoach
            key={title}
            isFirst={isFirst}
            isLast={isLast}
            isActive={isOnCurrentLocation}
            onClick={() => handleCourseClick(to, index)}
            style={{ minWidth: 160 }}
            showStatus={showStatus}
            isDone={currentCourse?.status}
          >
            {title}
          </CourseComponentItem>
        )
      })}
    </CourseComponentNav>
  )
}

export default CourseNav
